import Ajax from './ajax';

export const OVERDUE_LEAD_TASKS_LOADING = 'dashboarddata/overdueloadingtasks';
export const OVERDUE_LEAD_TASKS_LOADED = 'dashboarddata/overdueloadedtasks';
export const OVERDUE_LEAD_TASKS_FAILED = 'dashboarddata/overduefailedtasks';

export const UPCOMING_LEAD_TASKS_LOADING = 'dashboarddata/upcomingloadingtasks';
export const UPCOMING_LEAD_TASKS_LOADED = 'dashboarddata/upcomingloadedtasks';
export const UPCOMING_LEAD_TASKS_FAILED = 'dashboarddata/upcomingfailedtasks';

const initialState = {
    overdueLeadTasks: [],
    upcomingLeadTasks: [],
    loading: false,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case OVERDUE_LEAD_TASKS_LOADING: {
            return { ...state, loading: true };
        }

        case OVERDUE_LEAD_TASKS_LOADED: {
            return {
                ...state,
                overdueLeadTasks: action.tasks,
                loading: false,
            };
        }

        case OVERDUE_LEAD_TASKS_FAILED: {
            return {
                ...state,
                loading: false,
            };
        }

        case UPCOMING_LEAD_TASKS_LOADING: {
            return { ...state, loading: true };
        }

        case UPCOMING_LEAD_TASKS_LOADED: {
            return {
                ...state,
                upcomingLeadTasks: action.tasks,
                loading: false,
            };
        }

        case UPCOMING_LEAD_TASKS_FAILED: {
            return {
                ...state,
                loading: false,
            };
        }

        default:
            return state;
    }
}

export const getOverdueLeadTasks = () => {
    return (dispatch) => {
        dispatch({ type: OVERDUE_LEAD_TASKS_LOADING });

        return Ajax.get('api/salestask/overdue/')
            .then((result) => {
                dispatch({
                    type: OVERDUE_LEAD_TASKS_LOADED,
                    tasks: result.data,
                });
                return result.data;
            })
            .catch(() => {
                dispatch({ type: OVERDUE_LEAD_TASKS_FAILED });
                return null;
            });
    };
};

export const getUpcomingLeadTasks = () => {
    return (dispatch) => {
        dispatch({ type: UPCOMING_LEAD_TASKS_LOADING });

        return Ajax.get('api/salestask/upcoming/')
            .then((result) => {
                dispatch({
                    type: UPCOMING_LEAD_TASKS_LOADED,
                    tasks: result.data,
                });
                return result.data;
            })
            .catch(() => {
                dispatch({ type: UPCOMING_LEAD_TASKS_FAILED });
                return null;
            });
    };
};
